import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
//Components
import TextField from '../../../components/TextField/TextField';
import MainCard from '../../../components/MainCard/MainCard';
import Loading from '../../../components/Loading/Loading';

//Api
import ranking_api from '../../../api/ranking_api';
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';
import RelatorioRankingDeResiduos from './RelatorioRankingDeResiduos';

//Estado inicial dos filtros
function initialStateFiltros() {
    return {
        dataInicial: null,
        dataFinal: null,
        modalidadeId_selected: null,
        modalidadeId: null,
        nomeRelatorio: "Relatórios - Ranking por Residuos"
    }
}
export default function RankingDeResiduos() {
    //Variavel de navegação
    const navigate = useNavigate();
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado que guarda os dados dos filtros do ranking
    const [filtros, setFiltros] = useState(initialStateFiltros);
    //Estado que guarda os campos com erros
    const [errors, setErrors] = useState({});
    //Campos obrigatorios dos filtros
    const campos = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true })
    ]
    //Opções do select de modalidades
    const [optionsModalidade, setOptionsModalidades] = useState([]);

    //Estado de controle dos dados do relatorio do ranking na tela
    const [dadosRanking, setDadosRanking] = useState(null);

    //Função que carrega o relatorio do ranking
    const carregarRanking = () => {
        const _errors = validarCampos(filtros, campos);
        setErrors(_errors[0]);
        if (_errors[1].length > 0) {
            return;
        }
        setLoading(true);
        const _filtros = { ...filtros };
        _filtros.dataInicial = _filtros.dataInicial + " 00:00:00";
        _filtros.dataFinal = _filtros.dataFinal + " 23:59:59";
        ranking_api.Residuos(_filtros).then(response => {
            response.data.ranking = response.data.ranking.map(value => {
                value.coletado = parseFloat(value.coletado).toFixed(2).toString().replace(".", ",") + " KG";
                value.destinado = parseFloat(value.destinado).toFixed(2).toString().replace(".", ",") + " KG";
                return value;
            })
            setDadosRanking(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    };
    //OnChange para os campos de datas
    const onChangeData = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }
    //OnChange para o campo com pesquisa
    const onChangeModalidade = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e != null ? e.value : null
        })
    }
    //Carrega as opções do filtro de modalidade de coleta
    useEffect(() => {
        setLoading(true);
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao }
            })
            setOptionsModalidades(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);

    //Controle de exibição da tela do ranking
    if (dadosRanking) {
        return <RelatorioRankingDeResiduos btnVoltar={() => setDadosRanking(null)} dadosRanking={dadosRanking} filtros={filtros} />
    }
    return (
        <MainCard btnVoltar={() => navigate(-1)}>
            {loading && <Loading />}
            <h4>Ranking de resíduos</h4>
            <Row>
                <Col md="12" lg="4">
                    <TextField label={"Data inicial *"} type={"date"} name={'dataInicial'} value={filtros.dataInicial} onChange={onChangeData} invalid={!!errors.dataInicial} />
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Data final *"} type={"date"} name={'dataFinal'} value={filtros.dataFinal} onChange={onChangeData} invalid={!!errors.dataFinal} />
                </Col>
                <Col md="12" lg="4">
                    <TextField placeholder='Todos' label={"Modalidade de coleta"} options={optionsModalidade} value={filtros.modalidadeId_selected} type={"select"} searchable name={'modalidadeId_selected'} onChange={onChangeModalidade} />
                </Col>
                <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                    <Button className='w-100 fw-bold' color='info text-light' onClick={carregarRanking}>Gerar Relatório</Button>
                </Col>
            </Row>
        </MainCard>
    )
}